import { UserType } from '@/models/member'

const profile = state => {
  const { profile } = state
  const { firstName = '', lastName = '' } = profile
  const fullName = `${firstName} ${lastName}`.trim()

  return {
    ...profile,
    fullName
  }
}

const photoURL = state => state.photoURL

const memberTags = state => state.liteProfile?.tags

const memberUserTypeNonMember = state =>
  state.liteProfile?.userType === UserType.NON_MEMBER

const channelPersonId = state => state.profile?.channelPersonId

const memberFullName = (state, getters) => getters.profile?.fullName

const memberLastName = (state, getters) => getters.profile?.lastName

const userUpdatesDisabled = state => !state.profile?.editable

const memberName = state => {
  return (
    state.liteProfile.nickName ||
    state.liteProfile.socialName ||
    state.liteProfile.firstName
  )
}

export default {
  profile,
  photoURL,
  memberUserTypeNonMember,
  channelPersonId,
  memberFullName,
  memberTags,
  memberLastName,
  userUpdatesDisabled,
  memberName
}
